export default {
  header: 'Edit Business Card',
  cardNumber: 'Card number',
  expiryDate: 'Expiry date',
  cardholder: 'Name on card',
  postalCode: 'Postal code',
  update: 'Update',
};
